.backdrop {
  position: fixed;
  inset: 0;
  z-index: -1;
  overflow: hidden;
  background: var(--gb-surface);
  pointer-events: none;
}

.backdropArt {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.24;
  transform-origin: 50% 45%;
  animation: gb-camera-push var(--gb-camera-push) var(--gb-ease-out) forwards;
}

@keyframes gb-camera-push {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.07);
  }
}

.gameLogo {
  display: block;
  width: auto;
  max-width: min(100%, 44rem);
  max-height: clamp(5rem, 14vh, 11rem);
  object-fit: contain;
  object-position: left bottom;
}

.beat {
  animation: gb-beat-in var(--gb-motion-scene) var(--gb-ease-out) backwards;
}

@keyframes gb-beat-in {
  from {
    opacity: 0;
    transform: translateY(1.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.voltFlash {
  position: fixed;
  inset: 0;
  z-index: 90;
  background: var(--gb-signal-live);
  pointer-events: none;
  animation: gb-volt-flash var(--gb-motion) var(--gb-ease) forwards;
}

@keyframes gb-volt-flash {
  from {
    opacity: 0.85;
  }
  to {
    opacity: 0;
  }
}

.receipt {
  border: var(--gb-rule-width) solid var(--gb-text);
  background: var(--gb-surface-raised);
  padding: var(--gb-space-6);
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--gb-space-2) var(--gb-space-6);
  max-width: 32rem;
  font-family: var(--gb-font-mono);
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum' 1;
}

.receiptLabel {
  font-size: var(--gb-data-label);
  letter-spacing: var(--gb-tracking-data);
  text-transform: uppercase;
  color: var(--gb-text-muted);
  align-self: center;
}

.receiptValue {
  font-size: 0.9375rem;
  font-weight: 700;
  text-align: right;
  word-break: break-all;
}

.receiptRule {
  grid-column: 1 / -1;
  height: var(--gb-rule-width);
  background: var(--gb-rule);
}

.nothingYet {
  border-top: var(--gb-rule-width) solid var(--gb-rule);
  border-bottom: var(--gb-rule-width) solid var(--gb-rule);
  border-left: 3px solid var(--gb-accent);
  padding: var(--gb-space-12) var(--gb-space-8);
  display: flex;
  flex-direction: column;
  gap: var(--gb-space-4);
  background: var(--gb-surface-sunken);
}

.nothingYetHeadline {
  font-family: var(--gb-font-display);
  text-transform: uppercase;
  font-variation-settings:
    'wdth' 125,
    'wght' 900;
  font-size: clamp(1.75rem, 5vw, 3.5rem);
  line-height: 0.86;
  letter-spacing: -0.02em;
  margin: 0;
}

.soundToggle {
  display: inline-flex;
  align-items: center;
  gap: var(--gb-space-2);
  background: none;
  border: var(--gb-rule-width) solid var(--gb-rule);
  color: var(--gb-text-muted);
  padding: var(--gb-space-1) var(--gb-space-3);
  cursor: pointer;
  font-family: var(--gb-font-mono);
  font-size: var(--gb-data-label);
  letter-spacing: var(--gb-tracking-data);
  text-transform: uppercase;
  border-radius: var(--gb-radius);
  transition:
    color var(--gb-motion-fast) var(--gb-ease),
    border-color var(--gb-motion-fast) var(--gb-ease);
}

.soundToggle:hover {
  color: var(--gb-text);
  border-color: var(--gb-text-faint);
}

.soundToggleBars {
  display: inline-flex;
  align-items: flex-end;
  gap: 1px;
  height: 0.75rem;
  line-height: 0;
}

.soundToggleBars i {
  display: block;
  width: 2px;
  background-color: var(--gb-text-faint);
  transition: background-color var(--gb-motion-fast) var(--gb-ease);
}

.soundToggle[data-sound='on'] {
  color: var(--gb-text);
  border-color: var(--gb-accent);
}

.soundToggle[data-sound='on'] .soundToggleBars i {
  background-color: var(--gb-accent);
  animation: gb-sound-bob calc(var(--gb-motion-slow) * 2) var(--gb-ease) infinite alternate;
}

.soundToggle[data-sound='on'] .soundToggleBars i:nth-child(1) {
  animation-delay: 0ms;
}
.soundToggle[data-sound='on'] .soundToggleBars i:nth-child(2) {
  animation-delay: 110ms;
}
.soundToggle[data-sound='on'] .soundToggleBars i:nth-child(3) {
  animation-delay: 220ms;
}
.soundToggle[data-sound='on'] .soundToggleBars i:nth-child(4) {
  animation-delay: 330ms;
}
.soundToggle[data-sound='on'] .soundToggleBars i:nth-child(5) {
  animation-delay: 440ms;
}

@keyframes gb-sound-bob {
  from {
    transform: scaleY(0.55);
  }
  to {
    transform: scaleY(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .backdropArt,
  .beat,
  .voltFlash,
  .soundToggle[data-sound='on'] .soundToggleBars i {
    animation: none;
    transform: none;
  }

  .voltFlash {
    display: none;
  }
}
